setResetPasswordData